export const strings = {
  title: "Company Details",
  description: "View and manage your active employees.",
};
